import React from "react";
import Header from "./components/Header";
import { Box, Container, Divider } from "@mui/material";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import { Outlet, useLocation } from "react-router-dom";

const Layout = () => {
  const pathname = useLocation().pathname;
  return (
    <Box>
      <Box
        sx={{
          // light canvas with two soft brand glows — the "AI product" feel
          // without going dark
          position: "relative",
          background: "#F6F8FC",
          minHeight: "100vh",
          // the header is fixed, so every page needs that space reserved or
          // its first rows slide underneath it
          paddingTop: "72px",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            background:
              "radial-gradient(900px 420px at 85% -8%, rgba(124,58,237,.13), transparent 60%)," +
              "radial-gradient(760px 380px at 8% -6%, rgba(37,99,235,.14), transparent 62%)",
          },
          "& > *": { position: "relative", zIndex: 1 },
          // the header must outrank the hero band that follows it
          "& > .site-header": { zIndex: 1200 },
        }}
      >
        {!(pathname.includes("exams") && pathname.includes("questions")) && (
          <>
            <Container maxWidth="lg" className="site-header">
              {/* <Header /> */}
              <Navigation />
            </Container>
            <Divider sx={{ borderColor: "rgba(15,23,42,.08)", marginTop: "10px" }} />
          </>
        )}
        <Outlet />
      </Box>
      {!(pathname.includes("exams") && pathname.includes("questions")) && (
        <Footer />
      )}
    </Box>
  );
};

export default Layout;
